import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";
import { ApplyCloseEntityMemberCell } from "./ApplyCloseEntityMemberCell";

export const ApplyCloseEntityManagerCell = memo(
    function ApplyCloseEntityManagerCell({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        string
    >) {
        return (
            <ApplyCloseEntityMemberCell
                row={row}
                field="managerId"
                addText="Assign manager"
                emptyLabel="No manager"
            />
        );
    },
);
